/* eslint-disable react-doctor/use-lazy-motion */
import { Link, useLocation } from "@tanstack/react-router";
import { Button } from "@wags/ui/button.tsx";
import { cn } from "@wags/ui/ui-utils";
import type { ComponentProps, ReactNode } from "react";
import { PageErrorState } from "@/components/shared/ErrorState";

const LOST_TRAIL_REACTIONS = [
    "Hmm, this page ran off.",
    "We sniffed around but couldn't find this page.",
    "This trail's gone cold.",
    "Looks like this page found a new home.",
];

export function NotFound() {
    const pathname = useLocation({ select: (location) => location.pathname });
    const pathFingerprint = Array.from(pathname).reduce(
        (fingerprint, character) =>
            (fingerprint * 31 + (character.codePointAt(0) ?? 0)) >>> 0,
        0,
    );
    const title =
        LOST_TRAIL_REACTIONS[pathFingerprint % LOST_TRAIL_REACTIONS.length];

    return (
        <NotFoundState
            title={title}
            description="It may have moved, or the link may be outdated."
            actions={
                <Button asChild size="lg">
                    <Link to="/find">Find a dog</Link>
                </Button>
            }
        />
    );
}

export function NotFoundState({
    title,
    description,
    actions,
    className,
    scene = "lost",
}: {
    title: string;
    description: string;
    actions: ReactNode;
    className?: string;
    scene?: ComponentProps<typeof PageErrorState>["scene"];
}) {
    return (
        <PageErrorState
            className={cn("min-h-[80vh]", className)}
            title={title}
            description={description}
            actions={actions}
            scene={scene}
        />
    );
}
